import {debounce} from "debounce"
import getSkewBoxMargin from "../utils/GetSkewBoxMargin"
import loadingAnimation from '../components/LoadingAnimation/LoadingAnimation';
import jsCookie from 'js-cookie'

export default function() {
  const name = ".p-front-page";
  const wrapper = document.querySelector(name + '__visual');


  /**
   * transform: skew を設定した要素に、隙間が埋められる横幅を設定する
   * @param {Node} el
   * @param {Number} skewBoxMargin
   */
  const setSkewSizeWidth = (el, skewBoxMargin, percentage) => {
    const margin = skewBoxMargin;
    el.style.width = `calc(${percentage}% + ${margin}px)`;
  }


  /**
   * transform: skew を設定した要素のリサイズ
   */
  const resizeSkewBox = (resolve) => {
    const leftEl = document.querySelector(name + '__visual-left');
    const leftImg = leftEl.querySelector('.img');

    const rightEl = document.querySelector(name + '__visual-right');
    const rightImg = rightEl.querySelector('.img');

    const setStyleWidth = (margin) => {
      setSkewSizeWidth(leftEl, margin, 50.08);
      setSkewSizeWidth(leftImg, margin, 100);
      setSkewSizeWidth(rightEl, margin, 50.08);
      setSkewSizeWidth(rightImg, margin, 100);
    }

    // init
    let skewBoxMargin;
    skewBoxMargin = getSkewBoxMargin(wrapper, 65) / 2;
    setStyleWidth(skewBoxMargin);

    // resize event
    window.addEventListener('resize', debounce( () => {
      skewBoxMargin = getSkewBoxMargin(wrapper, 65) / 2;
      setStyleWidth(skewBoxMargin);
    }, 50));

    return resolve();
  }


  /**
   * メインビジュアルに読み込み完了後、アニメーションを始めるclassを付与
   */
  const visualAddLoadedClass = () => {
    const wrapper = document.querySelector(name + '__visual');
    wrapper.classList.add('is-loaded');
  }


  /**
   * アニメーションを省略するclassを付与
   */
  const skipAnimation = () => {
    const wrapper = document.querySelector(name + '__visual');
    wrapper.classList.add('is-skipped');
  }


  /**
   * 非同期でアニメーション
   * loadingAnimation() が完了後、処理を行う
   */
  const getCookie = jsCookie.get('opened_frontPage')

  if(!getCookie) {
    jsCookie.set('opened_frontPage', 1)
    return loadingAnimation()
      .then(()=>{ // 完了を待つ
        return new Promise((resolve, reject) => { // #1 skew要素のリサイズを適用
          setTimeout(() => {
            resizeSkewBox(resolve);
          }, 650);
        })
      })
      .then(() => { // #2 メインビジュアルに読み込み完了のclassを付与
        visualAddLoadedClass(); // start animation
    });

  } else {
    return new Promise((resolve, reject) => {
      resizeSkewBox(resolve);
    })
    .then(() => {
      skipAnimation();
    })
  }
}